<template>
  <div class="teachingActivity">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "teacherTextbook",
  components: {},
  data() {
    return {};
  },
  created() {},

  methods: {},
};
</script>

<style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
}
</style>